import React, { createContext, useState, useContext, useCallback } from 'react';
import {
    fetchStockTransfers, createStockTransfer, fetchTransferRequests, createTransferRequest,
    updateTransferRequest, approveTransferRequest, rejectTransferRequest, returnStockTransfer, returnStockTransferItems,
    fetchLowStockAlerts, printStockTransferReceipt
} from "../api/api";

const StockTransferContext = createContext();
export const useStockTransfers = () => useContext(StockTransferContext);

export const StockTransferProvider = ({ children }) => {
    const [transfers, setTransfers] = useState([]);
    const [requests, setRequests] = useState([]);
    const [transferCount, setTransferCount] = useState(0);
    const [requestCount, setRequestCount] = useState(0);
    const [alerts, setAlerts] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadTransfers = useCallback(async (filters = {}, page = 1) => {
        setLoading(true);
        try {
            const data = await fetchStockTransfers({...filters, page});
            setTransfers(data.results || data);
            setTransferCount(data.count ?? (data.results || data).length);
        } finally {
            setLoading(false);
        }
    }, []);

    const loadRequests = useCallback(async (page = 1) => {
        setLoading(true);
        try {
            const data = await fetchTransferRequests(page);
            setRequests(data.results || data);
            setRequestCount(data.count ?? (data.results || data).length);
        } finally {
            setLoading(false);
        }
    }, []);

    const loadAlerts = useCallback(async () => {
        try {
            const data = await fetchLowStockAlerts();
            setAlerts(data);
        } catch (error) {
            console.error("Error fetching low stock alerts:", error);
        }
    }, []);

    const addTransfer = async (payLoad) => {
        const data = await createStockTransfer(payLoad);
        await loadTransfers();
        await loadAlerts();
        return data;
    };

    const addRequest = async (payLoad) => {
        const data = await createTransferRequest(payLoad);
        await loadRequests();
        return data;
    };

    const editRequest = async (id, payLoad) => {
        const data = await updateTransferRequest(id, payLoad);
        await loadRequests();
        return data;
    };

    const approveRequest = async (id) => {
        const data = await approveTransferRequest(id);
        await loadRequests();
        await loadTransfers();
        await loadAlerts();
        return data;
    };

    const rejectRequestAction = async (id) => {
        const data = await rejectTransferRequest(id);
        await loadRequests();
        return data;
    };

    const returnTransferAction = async (id) => {
        const data = await returnStockTransfer(id);
        await loadTransfers();
        await loadAlerts();
        return data;
    }

    const returnTransferItemsAction = async (id, items) => {
        const data = await returnStockTransferItems(id, items);
        await loadTransfers();
        await loadAlerts();
        return data;
    };

    const printTransferReceiptAction = async (id) => {
        return printStockTransferReceipt(id);
    };

    return (
        <StockTransferContext.Provider
            value={{transfers, requests, transferCount, requestCount, alerts, loading, loadTransfers, loadRequests, loadAlerts, addTransfer,
                addRequest, editRequest, approveRequest, rejectRequestAction, returnTransferAction,
                returnTransferItemsAction, printTransferReceiptAction }}
        >
            {children}
        </StockTransferContext.Provider>
    );
};